<template>
  <div class="panel-container">
    <!-- 头部容器 -->
    <div class="header-container">
      <!-- 标题 -->
      <div class="title-container">
        <div class="symbol-icon"></div>
        <span class="title-text">{{ $str.getKey('收益管理/收益明细') }}</span>
      </div>
      <!-- 操作按钮 -->
      <div class="btns-container">
        <el-button jd-type="primary" type="primary" @click="handleExport">{{ $str.getKey('收益管理/导出') }}</el-button>
      </div>
    </div>
    <!-- 主体容器 -->
    <div class="main-container">
      <el-table :data="tableData" stripe class="hide-body-cell-border cell-flex-center">
        <!-- <el-table-column prop="time" label="时间" sortable min-width="120"></el-table-column> -->
        <el-table-column prop="time" :label="$str.getKey('收益管理/时间')" sortable min-width="105">
          <template #default="scope">
            <template v-if="scope && scope.row">
              <div :class="{'time-cell': true, 'abnormal': scope.row.abnormalInfo}">
                <span>{{ scope.row.time }}</span>
                <el-tooltip placement="top" popper-class="abnormal-popper-20250311" v-if="scope.row.abnormalInfo">
                  <template #content>
                    <div class="tip-info-wrapper">
                      <div>{{scope.row.abnormalInfo.tip}}</div>
                      <!-- <div>{{scope.row.abnormalInfo.origin}}</div> -->
                    </div>
                  </template>
                  <el-icon class="tip-icon">
                    <WarningFilled />
                  </el-icon>
                </el-tooltip>
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="productModel" :label="$str.getKey('收益管理/效率(%)')" sortable align="left">
          <template #default="scope">
            <template v-if="scope && scope.row">
              <span>{{ calculateEfficiency(scope.row) }}</span>
            </template>
          </template>
        </el-table-column>

        <!-- 充电量信息 -->
        <el-table-column :label="$str.getKey('收益管理/充电量(kWh)')" header-align="center" v-if="model === 1">
          <el-table-column prop="inSharp" :label="$str.getKey('收益管理/尖峰')" align="left" min-width="74">
          </el-table-column>
          <el-table-column prop="inPeak" :label="$str.getKey('收益管理/高峰')" align="left" min-width="74">
          </el-table-column>
          <el-table-column prop="inFlat" :label="$str.getKey('收益管理/平时段')" align="left" min-width="74">
          </el-table-column>
          <el-table-column prop="inValley" :label="$str.getKey('收益管理/低谷')" align="left" min-width="74">
          </el-table-column>
          <el-table-column prop="inDeepValley" :label="$str.getKey('收益管理/深谷')" align="left" min-width="74">
          </el-table-column>
          <el-table-column prop="inSum" :label="$str.getKey('收益管理/总')" align="left" min-width="74">
            <template #default="scope">
              <template v-if="scope && scope.row">
                <span style="font-weight: bold;">{{ scope.row.inSum }}</span>
              </template>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column prop="inSum" :label="$str.getKey('收益管理/充电量(kWh)')" v-else></el-table-column>

        <!-- 放电量信息 -->
        <el-table-column :label="$str.getKey('收益管理/放电量(kWh)')" header-align="center" v-if="model === 1">
          <el-table-column prop="outSharp" :label="$str.getKey('收益管理/尖峰')" align="left" min-width="74">
          </el-table-column>
          <el-table-column prop="outPeak" :label="$str.getKey('收益管理/高峰')" align="left" min-width="74">
          </el-table-column>
          <el-table-column prop="outFlat" :label="$str.getKey('收益管理/平时段')" align="left" min-width="74">
          </el-table-column>
          <el-table-column prop="outValley" :label="$str.getKey('收益管理/低谷')" align="left" min-width="74">
          </el-table-column>
          <el-table-column prop="outDeepValley" :label="$str.getKey('收益管理/深谷')" align="left" min-width="74">
          </el-table-column>
          <el-table-column prop="outSum" :label="$str.getKey('收益管理/总')" align="left" min-width="74">
            <template #default="scope">
              <template v-if="scope && scope.row">
                <span style="font-weight: bold;">{{ scope.row.outSum }}</span>
              </template>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column prop="outSum" :label="$str.getKey('收益管理/放电量(kWh)')" v-else></el-table-column>

        <el-table-column prop="incomeSum" :label="$str.getKey('收益管理/收益(元)')" align="left" sortable min-width="110">
        </el-table-column>
        <el-table-column prop="priceInfo" :label="$str.getKey('收益管理/电价')" align="left">
          <template #default="scope">
            <template v-if="scope && scope.row">
              <el-popover 
                trigger="hover" 
                placement="top" 
                width="660"
                :show-after="0"
                :hide-after="0"
                popper-class="price-popover-unique"
                @show="() => handlePopoverShow(scope.$index)"
                @hide="() => handlePopoverHide(scope.$index)">
                <el-table :data="scope.row.priceInfo" width="660" class="cell-flex-center">
                <el-table-column prop="type" :label="$str.getKey('收益管理/类型')"></el-table-column>
                <el-table-column :label="$str.getKey('收益管理/电价(元/kWh)')">
                  <el-table-column prop="sharp" :label="$str.getKey('收益管理/尖峰')" min-width="90"></el-table-column>
                  <el-table-column prop="peak" :label="$str.getKey('收益管理/高峰')" min-width="90"></el-table-column>
                  <el-table-column prop="flat" :label="$str.getKey('收益管理/平时段')" min-width="90"></el-table-column>
                  <el-table-column prop="valley" :label="$str.getKey('收益管理/低谷')" min-width="90"></el-table-column>
                  <el-table-column prop="deepValley" :label="$str.getKey('收益管理/深谷')" min-width="90"></el-table-column>
                </el-table-column>
                </el-table>
                <template #reference>
                  <div 
                    class="price-detail-cell"
                    @mouseenter="() => handleCellMouseEnter(scope.$index)"
                    @mouseleave="() => handleCellMouseLeave(scope.$index)">
                    <span>{{ $str.getKey('收益管理/详情') }}</span>
                  </div>
                </template>
              </el-popover>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted, onBeforeUnmount, nextTick } from "vue"
import dayjs from 'dayjs';
import { ElMessageBox } from "element-plus";
import { download, download_get } from "@/api/modules/download/index.js";

const $str = window.$str;

/** 设置组件配置项 */
defineOptions({
  name: "chartPanel"
});

/** 接收父组件信息 */
const props = defineProps({
  tableData: {
    type: Object,
    default: {
      list: [],
    }
  },
  meterUuid: {
    type: String,
    default: '',
  }
});

const model = computed(() => props.tableData?.incomeModel);
const tableData = computed(() => props.tableData?.list || []);

// 用于跟踪和调试
let popoverShowCount = 0;
let popoverHideCount = 0;
const popoverStates = new Map(); // 记录每个popover的状态

initPanel();



/** ====== [业务：功能方法] =================================================================== */
/** 初始化面板 */
function initPanel() {
  // 不需要定时器，只在鼠标事件时打印日志
}

/** 处理单元格鼠标进入事件 */
function handleCellMouseEnter(index) {
  console.log(`\n========== 鼠标进入详情单元格 [索引: ${index}] ==========`);
  console.log(`时间: ${new Date().toLocaleTimeString()}`);
  
  // 立即关闭所有其他可见的popover，确保切换时没有延迟
  const allPopovers = document.querySelectorAll('.price-popover-unique');
  const allDetailCells = document.querySelectorAll('.price-detail-cell');
  const currentCell = allDetailCells[index];
  
  const visiblePopovers = Array.from(allPopovers).filter(popover => {
    const style = window.getComputedStyle(popover);
    const rect = popover.getBoundingClientRect();
    return style.display !== 'none' && 
           style.visibility !== 'hidden' && 
           style.opacity !== '0' &&
           rect.width > 0 && 
           rect.height > 0;
  });
  
  console.log(`当前DOM中的popover总数: ${allPopovers.length}`);
  console.log(`当前可见的popover数量: ${visiblePopovers.length}`);
  
  if (visiblePopovers.length > 0 && currentCell) {
    console.warn(`⚠️ 警告: 鼠标进入索引 ${index} 时，已有 ${visiblePopovers.length} 个popover可见！立即关闭它们...`);
    
    const currentCellRect = currentCell.getBoundingClientRect();
    
    visiblePopovers.forEach((popover, i) => {
      const popoverRect = popover.getBoundingClientRect();
      const style = window.getComputedStyle(popover);
      console.log(`  可见popover[${i}]: display=${style.display}, visibility=${style.visibility}, opacity=${style.opacity}, 位置=(${popoverRect.left}, ${popoverRect.top}), 大小=(${popoverRect.width}x${popoverRect.height})`);
      
      // 检查这个popover是否不对应当前的cell
      const isCurrentPopover = Math.abs(popoverRect.left - currentCellRect.left) < 50 && 
                               popoverRect.top < currentCellRect.top;
      
      // 如果不是当前的popover，立即关闭它
      if (!isCurrentPopover) {
        // 找到对应的cell并触发mouseleave事件
        allDetailCells.forEach((cell, cellIndex) => {
          if (cellIndex !== index) {
            const cellRect = cell.getBoundingClientRect();
            if (Math.abs(popoverRect.left - cellRect.left) < 50 && 
                popoverRect.top < cellRect.top) {
              console.log(`    关闭popover[${i}]，对应cell索引: ${cellIndex}`);
              // 触发mouseleave事件来关闭popover
              const mouseLeaveEvent = new MouseEvent('mouseleave', {
                bubbles: true,
                cancelable: true,
                view: window
              });
              cell.dispatchEvent(mouseLeaveEvent);
            }
          }
        });
      }
    });
  }
  
  // 检查popover状态记录
  const stateEntries = Array.from(popoverStates.entries());
  if (stateEntries.length > 0) {
    console.log(`Popover状态记录:`, stateEntries.map(([idx, state]) => `索引${idx}=${state.status}`).join(', '));
  }
  
  console.log(`等待popover显示事件触发...`);
}

/** 处理单元格鼠标离开事件 */
function handleCellMouseLeave(index) {
  console.log(`\n========== 鼠标离开详情单元格 [索引: ${index}] ==========`);
  console.log(`时间: ${new Date().toLocaleTimeString()}`);
  
  // 检查当前所有popover的状态
  const allPopovers = document.querySelectorAll('.price-popover-unique');
  const visiblePopovers = Array.from(allPopovers).filter(popover => {
    const style = window.getComputedStyle(popover);
    const rect = popover.getBoundingClientRect();
    return style.display !== 'none' && 
           style.visibility !== 'hidden' && 
           style.opacity !== '0' &&
           rect.width > 0 && 
           rect.height > 0;
  });
  
  console.log(`当前可见的popover数量: ${visiblePopovers.length}`);
  if (visiblePopovers.length > 0) {
    visiblePopovers.forEach((popover, i) => {
      const style = window.getComputedStyle(popover);
      const rect = popover.getBoundingClientRect();
      console.log(`  仍可见popover[${i}]: display=${style.display}, visibility=${style.visibility}, opacity=${style.opacity}`);
    });
  }
  
  console.log(`等待popover隐藏事件触发...`);
}

/** 处理 popover 显示事件 */
function handlePopoverShow(index) {
  popoverShowCount++;
  popoverStates.set(index, { status: 'showing', time: Date.now() });
  
  console.log(`\n✅ [Popover显示成功] 索引: ${index}`);
  console.log(`   总显示次数: ${popoverShowCount}`);
  console.log(`   时间: ${new Date().toLocaleTimeString()}`);
  
  // 检查是否有其他popover正在显示
  const allPopovers = document.querySelectorAll('.price-popover-unique');
  const visiblePopovers = Array.from(allPopovers).filter(popover => {
    const style = window.getComputedStyle(popover);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  });
  
  if (visiblePopovers.length > 1) {
    console.error(`❌ 错误: 索引 ${index} 显示时，发现 ${visiblePopovers.length} 个popover同时可见！`);
    console.error(`   这可能导致后续popover无法正常显示！`);
  } else {
    console.log(`   当前只有 ${visiblePopovers.length} 个popover可见，状态正常`);
  }
  
  // 打印所有popover状态
  const stateEntries = Array.from(popoverStates.entries());
  if (stateEntries.length > 0) {
    console.log(`   所有popover状态:`, stateEntries.map(([idx, state]) => `索引${idx}=${state.status}`).join(', '));
  }
}

/** 处理 popover 隐藏事件 */
function handlePopoverHide(index) {
  popoverHideCount++;
  popoverStates.set(index, { status: 'hidden', time: Date.now() });
  
  console.log(`\n❌ [Popover隐藏] 索引: ${index}`);
  console.log(`   总隐藏次数: ${popoverHideCount}`);
  console.log(`   时间: ${new Date().toLocaleTimeString()}`);
  
  // 检查是否还有可见的popover
  const allPopovers = document.querySelectorAll('.price-popover-unique');
  const visiblePopovers = Array.from(allPopovers).filter(popover => {
    const style = window.getComputedStyle(popover);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  });
  
  if (visiblePopovers.length > 0) {
    console.warn(`⚠️ 警告: popover隐藏后，仍有 ${visiblePopovers.length} 个popover可见`);
  } else {
    console.log(`   所有popover已隐藏，状态正常`);
  }
}





/** ====== [辅助：功能方法] =================================================================== */
/** 计算效率：放/充比值 */
function calculateEfficiency(row) {
  if (!row || typeof row !== 'object') {
    return "--";
  }
  if (row.inSum == null || row.outSum == null || row.inSum === 0) {
    return "--";
  }
  const ratio = row.outSum / row.inSum;
  if (row.outSum >= 0 && ratio > 0.8 && ratio < 0.99) {
    return (ratio * 100).toFixed(1);
  } else {
    return "--";
  }
}

/** 导出收益明细表格数据 */
function handleExport() {
  ElMessageBox.confirm($str.getKey('收益管理/是否确认导出所有数据项？'), $str.getKey('收益管理/提示'), {
    confirmButtonText: $str.getKey('收益管理/确定'),
    cancelButtonText: $str.getKey('收益管理/取消'),
    type: 'warning',
  }).then(() => {
    const params = {
      stationId: props.tableData.stationId,
      startTime: dayjs(props.tableData.exportTimeRange[0]).format('YYYY-MM-DD 00:00:00'),
      endTime: dayjs(props.tableData.exportTimeRange[1]).format('YYYY-MM-DD 23:59:59'),
      uuid: props.meterUuid === 'all' ? '' : (props.meterUuid !== 'undefined' ? props.meterUuid : ''),
    }
    // download(
    //   "/dashboard/income/export",
    //   params,
    //   `iconme_${new Date().getTime()}.xlsx`
    // );
    download_get('/dashboard/income/export', params, `iconme_${new Date().getTime()}.xlsx`)
  })
}



</script>
<style lang="scss" scoped>
.panel-container {
  --page-top: 12px;
  --header-hight: 50px;
  & {
    width: 100%;
    // height: calc(100% - var(--page-top));
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.63) 0%, rgba(255, 255, 255, 0.42) 100%);
    border-radius: 20px;
    border: 0.5px solid rgba(255, 255, 255, 1);
    backdrop-filter: blur(10px);
    // margin-top: var(--page-top);
    padding: 10px;

    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .header-container {
    width: 100%;
    height: var(--header-hight);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-container {
      max-width: 50%;
      height: 100%;
      padding-left: 0;
      display: flex;
      align-items: center;
      gap: 6px;
      background-color: #FFF;
      .title-text {
        color: #2E2E2E;
        font-family: "HarmonyOS Sans SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }

    .btns-container {
      max-width: 50%;
      height: 100%;
      padding-right: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      // gap: 10px;

      // 导出按钮背景色设置为与主页面背景色一致
      :deep(.el-button) {
        background-color: #ffffff !important; // 与主页面背景色一致
        border-color: #dcdfe6; // 保持边框颜色，确保按钮可见
        color: #2E2E2E;
        font-family: "HarmonyOS Sans SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
  }

  .main-container {
    & {
      width: 100%;
      height: calc(100% - var(--header-hight));
      flex: 1;
      overflow: scroll;
      padding: 10px;
      display: grid;
      grid-template-rows: 1fr;
    }

    ::v-deep .el-table {
      width: 100%;
      height: 100%;

      // 表头背景色设置为与主页面背景色一致
      .el-table__header-wrapper {
        .el-table__header {
          thead {
            tr {
              th {
                background-color: #ffffff !important; // 与主页面背景色一致
              }
            }
          }
        }
      }

      .time-cell {
        display: flex;
        align-items: center;
        gap: 6px;
        &.abnormal {
          color: orange;
        }
      }

      .price-detail-cell {
        width: 100%;
        height: 100%;
        color: #5165E1;
        cursor: pointer;
      }

      // 表格内容（不包括表头）的字体样式
      .el-table__body .cell {
        color: #444A6D;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: "HarmonyOS Sans SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

    }

  }

}

</style>
<style>
.abnormal-popper-20250311 {
  .tip-info-wrapper {
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
}

/* 确保同一时间只有一个价格详情 popover 显示 */
.price-popover-unique {
  z-index: 2000;
}

/* 隐藏所有被标记为隐藏的 popover */
.price-popover-unique[style*="display: none"] {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
}
</style>
